import { useStore } from '../store/useStore';

export interface DialogOption {
    label: string;
    nextStepId: string;
    action?: () => void;
}

export interface DialogStep {
    id: string;
    text: string;
    options?: DialogOption[];
}

export interface Dialog {
    id: string;
    startStepId: string;
    speaker?: string; // Optional on root if steps handle it, but we use it for Npc name usually
    text?: string;
    steps: Record<string, DialogStep>;
}

export const dialogs: Record<string, Dialog> = {
    'guide_welcome': {
        id: 'guide_welcome',
        speaker: 'Guide',
        startStepId: 'start',
        text: 'Welcome, traveler! This world is full of mysteries.',
        // Wait, the structure in file is inconsistent with my thought.
        // The interface has steps: Record<string, DialogStep>.
        // Let's fix the content to match the complex structure used in guide_welcome.
        steps: {
            'start': {
                id: 'start',
                text: 'Welcome, traveler! I have a task for you.',
                options: [
                    { label: 'What is it?', nextStepId: 'task_explain' },
                    { label: 'Not now.', nextStepId: 'end' }
                ]
            },
            'task_explain': {
                id: 'task_explain',
                text: 'I lost a Gold Coin nearby. Can you find it for me?',
                options: [
                    {
                        label: 'I will find it.',
                        nextStepId: 'end',
                        action: () => useStore.getState().startQuest('collect_coin')
                    }
                ]
            },
            'end': {
                id: 'end',
                text: 'Good luck!',
                options: []
            }
        }
    },
    'blacksmith_intro': {
        id: 'blacksmith_intro',
        speaker: 'Blacksmith',
        startStepId: 'start',
        text: '',
        steps: {
            'start': {
                id: 'start',
                text: 'Hammering all day... You look tough. Want to help me with a pest problem?',
                options: [
                    { label: 'Sure!', nextStepId: 'accept_quest' },
                    { label: 'Maybe later.', nextStepId: 'end' }
                ]
            },
            'accept_quest': {
                id: 'accept_quest',
                text: 'Great! Go to the Arena and defeat 3 enemies. I will reward you.',
                options: [
                    {
                        label: 'I am on it.',
                        nextStepId: 'end',
                        action: () => useStore.getState().startQuest('pest_control')
                    }
                ]
            },
            'end': {
                id: 'end',
                text: 'Come back when you are done.',
                options: []
            }
        }
    },
    'farmer_intro': {
        id: 'farmer_intro',
        speaker: 'Farmer',
        startStepId: 'start',
        text: '',
        steps: {
            'start': {
                id: 'start',
                text: 'My crops are growing well. The About house tells a good story too.',
                options: [
                    { label: 'Good to know.', nextStepId: 'end' }
                ]
            },
            'end': {
                id: 'end',
                text: 'Take care now.',
                options: []
            }
        }
    },
    'villager_intro': {
        id: 'villager_intro',
        speaker: 'Lost Villager',
        startStepId: 'start',
        text: '',
        steps: {
            'start': {
                id: 'start',
                text: 'I was looking for the Apps house... oh, it is right here!',
                options: [
                    { label: 'Glad you found it.', nextStepId: 'end' }
                ]
            },
            'end': {
                id: 'end',
                text: 'See you around.',
                options: []
            }
        }
    }
};
